import { create } from 'zustand';

interface DemoStore {
  active: boolean;
  firstProjectId?: string;
  start: (firstProjectId?: string) => void;
  stop: () => void;
}

export const useDemoStore = create<DemoStore>((set) => ({
  active: false,
  firstProjectId: undefined,
  start: (firstProjectId) => set({ active: true, firstProjectId }),
  stop: () => set({ active: false, firstProjectId: undefined }),
}));
